/* eslint-disable prettier/prettier */
/*
public function show_AllgemeineVertragsangaben()
    {
        // Options Headline
        // Titel
        $this->textflow = $this->pdf->add_textflow($this->textflow, "Allgemeine Vertragsangaben", $this->boldOptions . " fillcolor=" . $this->colors->rgb->headline);
        // $this->textflow = $this->pdf->add_textflow($this->textflow,"\n",$this->distanceOptions);
        $this->dumpThisTextflow();
        // Beginn und Ende
        $beginString = $this->viergewinnt->offerRequest->contract->beginn;
        $beginDate = strtotime($beginString);
        $von = date("d.m.Y", $beginDate);
        // Sonderlocke Schaltjahr
        $test = substr($beginString, -5, 5);
        if ($test == '02-29') {
            $beginString = str_replace('02-29', '02-28', $beginString);
            $beginDate = strtotime($beginString);
        }

        $endDate = strtotime('+ 1 year', $beginDate);
        $bis = date("d.m.Y", $endDate);
        $beginn = "Vertragsbeginn\t" . $von . " 0:00 Uhr";
        $ende = "Vertragsende\t" . $bis . " 0:00 Uhr";
        $this->textflow = $this->pdf->add_textflow($this->textflow, $beginn . "\n" . $ende . "\n", $this->regularOptions . $this->signalColorOption);
        $this->dumpThisTextflow();
        // Copy
        $copy = "Die Versicherung läuft bis zum angegebenen Vertragsende. Sie haben die Möglichkeit den Vertrag jeweils monatlich zur Beitragsfälligkeit unter Einhaltung einer Frist von einem Monat in Textform zu kündigen. Wir können den Vertrag jeweils zum Ablauf unter Einhaltung einer Frist von drei Monaten in Schriftform kündigen.";
        $this->textflow = $this->pdf->add_textflow($this->textflow, $copy . "\n\n", $this->regularOptions . $this->defaultColorOption);
        // Fälligkeit
        $trueBeginDate = strtotime($this->viergewinnt->offerRequest->contract->beginn);
        $copy = "Beitragsfälligkeit\tmonatlich, jeweils am " . date("d", $trueBeginDate) . ". eines Monats";
        // Zusatz-String, falls der Tag auf den 29., 30. oder 31. fällt
        $test = date("d", $trueBeginDate);
        if ($test == '29' || $test == '30' || $test == '31') {
            $copy .= ", bzw. am Monatsende, falls der Monat weniger Tage hat";
        }
        $this->textflow = $this->pdf->add_textflow($this->textflow, $copy . "\n", $this->regularOptions . $this->signalColorOption);
        $this->dumpThisTextflow();
    }
*/

const allgemeineVertragsangaben = {
    text: [
        { text: "Allgemeine Vertragsangaben\n\n", style: "subHeadOptions" },
        { text: "Vertragsbeginn\t\t\t__beginn__ 0:00 Uhr\n", style: "regularOptions" },
        { text: "Vertragsende\t\t\t\t__ende__ 0:00 Uhr\n\n", style: "regularOptions" },
        { text: "Die Versicherung läuft bis zum angegebenen Vertragsende. Sie haben die Möglichkeit den Vertrag jeweils monatlich zur Beitragsfälligkeit unter Einhaltung einer Frist von einem Monat in Textform zu kündigen. Wir können den Vertrag jeweils zum Ablauf unter Einhaltung einer Frist von drei Monaten in Schriftform kündigen.\n\n", style: "regularOptions" },
        { text: "Beitragsfälligkeit\t\tmonatlich, jeweils am __trueBeginDateDay__. eines Monats\n", style: "regularOptions" }
    ],
    margin: [0, 20, 0, 0]
}

export { allgemeineVertragsangaben }